import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { CssVarsProvider } from '@mui/joy/styles'
import theme from './theme'
import './index.css'
import './utils/consoleFilter.js' // Clean up console in development
import App from './App.jsx'
import { AuthProvider } from './context/AuthContext';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <CssVarsProvider theme={theme} defaultMode="light" modeStorageKey={null}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </CssVarsProvider>
  </StrictMode>,
)
